"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationDirection = void 0;
/**
 * {@docCategory Calendar}
 */
var AnimationDirection;
(function (AnimationDirection) {
    /**
     * Grid will transition out and in horizontally
     */
    AnimationDirection[AnimationDirection["Horizontal"] = 0] = "Horizontal";
    /**
     * Grid will transition out and in vertically
     */
    AnimationDirection[AnimationDirection["Vertical"] = 1] = "Vertical";
})(AnimationDirection || (exports.AnimationDirection = AnimationDirection = {}));
//# sourceMappingURL=Calendar.types.js.map